import PropTypes from 'prop-types';

import { CustomTypography } from 'src/components/CustomTypography';
import { PersonaAvatar } from 'src/components/PersonaAvatar';
import TextLink from 'src/components/TextLink';

import { useStyles } from './useStyles';

export const UpdatePersonaBrandVoiceNotification = ({ onClick, savedPersona }) => {
  const styles = useStyles();

  return (
    <div className={styles.notificationWrapper}>
      <div className={styles.notification}>
        <div className={styles.notificationText}>
          <PersonaAvatar
            className={styles.avatar}
            avatarType={savedPersona?.avatarType || 'avatar_one'}
            opaqueBackground={false}
          />
          <CustomTypography>
            Saved to brand voice:{' '}
            <span className={styles.name}>{savedPersona.brandVoice.name}</span>.
          </CustomTypography>
        </div>
        <TextLink
          className={styles.link}
          onClick={onClick}
        >
          Change
        </TextLink>
      </div>
    </div>
  );
};

UpdatePersonaBrandVoiceNotification.propTypes = {
  onClick: PropTypes.func,
  savedPersona: PropTypes.shape({
    avatarType: PropTypes.string,
    brandVoice: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
};
UpdatePersonaBrandVoiceNotification.defaultProps = {
  onClick: null,
  savedPersona: null,
};
